import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as GLOBAL from '../../globals';

@Injectable()
export class AuthGuardService implements CanActivate {

    private token: string;

    constructor(private router: Router, private jwtHelper: JwtHelperService) {

    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        try {

            this.token = this.jwtHelper.tokenGetter();

            if (this.token === null || this.jwtHelper.isTokenExpired(this.token)) {

                window.location.href = GLOBAL.authURL + '?returnto=' + GLOBAL.toolURL + state.url;
                return false;
            }

            return true;

        } catch (err) {
            console.log(err);
            return false;
        }


    }

}


@Injectable()
export class AuthTokenReceiver implements CanActivate {

    constructor(private router: Router, private jwtHelper: JwtHelperService) {

    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        try {
            
            if (route.queryParams['token'] != null && !this.jwtHelper.isTokenExpired(route.queryParams['token'])) {

                sessionStorage.setItem('act_agcl', route.queryParams['token']);

                const usr = this.jwtHelper.decodeToken(route.queryParams['token']);
                
                sessionStorage.setItem('uid', usr.user._id);
                sessionStorage.setItem('uname', usr.user.name);

                this.router.navigate([window.location.href.match(/\/tools\/sas\/(.*)\?/)[1]]);

            }

            return true;

        } catch (err) {
            return false;
        }


    }

}
